'use client'

import { IFRAME_SEARCH_PARAM_KEYS, IframeSearchParamKeys } from '@/constants/iframe'
import { getWorldsDomain } from '@/lib/configs'

type BuildShareUrlParams = Partial<Record<IframeSearchParamKeys, boolean>>

export const buildShareUrl = (roomId: string, params: BuildShareUrlParams) => {
  const searchParams = new URLSearchParams()

  if (params.view) {
    searchParams.append(IFRAME_SEARCH_PARAM_KEYS.VIEW, '')
  }

  const queryString = searchParams.toString()
  return `https://${getWorldsDomain()}/${queryString ? `${roomId}?${queryString}` : roomId}`
}
